import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UserPhoneNumber extends RestApiModel {

  static getResourceEndpoint() {
    return '/user/phone-number';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default UserPhoneNumber;
